(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["empreinte-copy-fix"] && !Shopify.designMode) return;
  try {
    
(function () {
  function applyEmpreinteHomeCopy() {
    var hero = document.querySelector('.ee-home .ee-hero');
    if (hero) {
      var heroKicker = hero.querySelector('.ee-kicker');
      if (heroKicker) {
        heroKicker.textContent = 'Plus qu’un objet, un souvenir à créer à deux';
      }

      var heroTitle = hero.querySelector('h1');
      if (heroTitle) {
        heroTitle.textContent = 'Et si vous pouviez garder ce geste pour toujours ?';
      }

      var heroCuriosity = hero.querySelector('.ee-hero-curiosity');
      if (heroCuriosity) {
        heroCuriosity.textContent = 'Vos mains changent avec le temps. Leur empreinte, elle, peut rester.';
      }

      var heroPromise = hero.querySelector('.ee-hero-promise');
      if (heroPromise) {
        heroPromise.innerHTML = 'Un <strong>kit de moulage 3D pour deux mains enlacées</strong>. Créez votre sculpture à deux, puis gardez ce souvenir auprès de vous.';
      }

      var heroButton = hero.querySelector('.ee-btn');
      if (heroButton) {
        heroButton.textContent = 'Créer notre empreinte →';
      }
    }

    var introSection = document.querySelector('.ee-home > .ee-section[data-home-intro]');

    if (introSection) {
      var kicker = introSection.querySelector('.ee-kicker');
      if (kicker) kicker.remove();

      var title = introSection.querySelector('.ee-title');
      if (title) {
        title.textContent = 'Un geste à garder pour toujours.';
      }

      var lead = introSection.querySelector('.ee-lead');
      if (lead) {
        lead.innerHTML = '<strong>Empreinte Éternelle garde le geste.</strong><br><br>Tenir une main paraît ordinaire sur le moment. Pourtant, avec le temps, les mains changent et les étapes de la vie passent.<br><br>Empreinte Éternelle transforme ces instants en sculptures 3D fidèles de vos mains, pour conserver bien plus qu’une image : un geste, une émotion, un souvenir à toucher.';
      }
    }

    var sections = document.querySelectorAll('.ee-home .ee-section');
    sections.forEach(function (section) {
      var sectionKicker = section.querySelector('.ee-kicker');
      if (sectionKicker && sectionKicker.textContent.trim().toLowerCase() === 'un univers pour chaque lien') {
        var universeLead = section.querySelector('.ee-lead');
        if (universeLead) {
          universeLead.innerHTML = 'Empreinte Éternelle imagine des expériences de moulage 3D pour immortaliser les liens qui comptent : les mains d’un couple, les petites mains d’un bébé, celles d’un enfant ou toute une famille.<br><br>Aujourd’hui, l’histoire commence avec notre <strong>Format Duo</strong>, pensé pour créer à deux un souvenir unique à conserver.';
        }
      }

      if (sectionKicker && sectionKicker.textContent.trim().toLowerCase() === 'notre histoire') {
        var storyTitle = section.querySelector('.ee-title');
        if (storyTitle) {
          storyTitle.textContent = 'Des souvenirs qu’on peut toucher.';
        }

        var storyLead = section.querySelector('.ee-lead');
        if (storyLead) {
          storyLead.innerHTML = 'Empreinte Éternelle est née d’une idée simple : certains souvenirs méritent mieux qu’une place au fond d’une galerie de téléphone.<br><br>Tenir une main paraît ordinaire sur le moment. Pourtant, avec le temps, les gestes changent, les mains évoluent et les étapes de la vie passent.';
        }

        var storyCard = section.querySelector('.ee-copy-card');
        if (storyCard) {
          var storyCardText = storyCard.querySelector('p');
          if (storyCardText) {
            storyCardText.innerHTML = 'Notre envie est de transformer ces instants simples en souvenirs que l’on peut créer ensemble, conserver et transmettre.<br><br>À travers le moulage 3D des mains, Empreinte Éternelle imagine des créations personnelles pour les couples, les enfants, les bébés et les familles.';
          }
        }
      }
    });

    var compareSection = document.querySelector('#pourquoi');
    if (compareSection) {
      var compareKicker = compareSection.querySelector('.ee-kicker');
      if (compareKicker) {
        compareKicker.textContent = 'Plus qu’un cadeau, un souvenir à vivre';
      }

      var compareTitle = compareSection.querySelector('.ee-title');
      if (compareTitle) {
        compareTitle.textContent = 'Certains cadeaux s’oublient. Certains moments restent.';
      }

      var cards = compareSection.querySelectorAll('.ee-compare-card');
      if (cards[0]) {
        var firstList = cards[0].querySelector('ul');
        if (firstList) {
          firstList.innerHTML = '<li>On l’ouvre</li><li>On l’utilise quelque temps</li><li>Puis il finit parfois par disparaître du quotidien</li>';
        }
      }

      if (cards[1]) {
        var secondList = cards[1].querySelector('ul');
        if (secondList) {
          secondList.innerHTML = '<li>Vous créez quelque chose ensemble</li><li>Le moment fait déjà partie du souvenir</li><li>Et la sculpture reste comme une trace de ce que vous avez vécu</li>';
        }
      }

      var compare = compareSection.querySelector('.ee-compare');
      var conclusion = compareSection.querySelector('.ee-compare-conclusion');
      if (!conclusion && compare) {
        conclusion = document.createElement('p');
        conclusion.className = 'ee-lead ee-compare-conclusion';
        conclusion.style.marginTop = '28px';
        compare.insertAdjacentElement('afterend', conclusion);
      }
      if (conclusion) {
        conclusion.innerHTML = '<strong>Parce que la vraie valeur n’est pas seulement dans ce que l’on garde, mais dans le moment que l’on partage pour le créer.</strong>';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyEmpreinteHomeCopy);
  } else {
    applyEmpreinteHomeCopy();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["empreinte-premium-product"]) return;
  try {
    
(function(){
  function initPremium(){
    document.querySelectorAll('[data-premium-product]').forEach(function(root){
      if(root.dataset.initialized)return;
      var config;
      try{config=JSON.parse(root.querySelector('[data-premium-config]').textContent);}catch(error){return;}
      root.dataset.initialized='true';
      var select=root.querySelector('[data-premium-select]');
      var pickers=root.querySelector('[data-visual-pickers]');
      var image=root.querySelector('.eex-main-image');
      var mainBuy=root.querySelector('[data-premium-buy]');
      var stock=root.querySelector('[data-premium-stock]');
      var variants=config.variants;
      var names=config.optionNames.slice();
      var colors={'Blanc':'#fffdf9','Noir':'#302c29','Ton bois':'#c2a16c','Beige':'#d6c6ad','Gris':'#999c9e','Bleu foncé':'#304559','Rouge':'#ae343a'};
      var formatSizes={A:'33,5 × 32,5 cm',B:'28 × 27 cm',C:'18 × 17,5 cm'};
      function transformed(variant){
        if(config.kind==='frames'){
          var parts=variant.options[0].split(' — ');
          return [parts[0],parts[1],variant.options[1]];
        }
        if(config.kind==='album')return variant.options[0].split(' — Format ');
        return variant.options.slice();
      }
      variants.forEach(function(variant){variant.choices=transformed(variant);});
      if(config.kind==='frames')names=[config.labels.finish,config.labels.quantity,config.labels.photoSize];
      if(config.kind==='album')names=[config.labels.color,config.labels.format];
      if(config.personalized)names=[config.plaqueCopy.modelStep,config.plaqueCopy.baseStep];
      var current=variants.find(function(v){return String(v.id)===select.value;})||variants[0];
      var choices=current.choices.slice();
      var values=names.map(function(name,index){return Array.from(new Set(variants.map(function(v){return v.choices[index];})));});
      if(config.kind==='frames')values[2].sort(function(a,b){return parseFloat(a.replace(',','.'))-parseFloat(b.replace(',','.'));});
      if(config.kind==='album')values[1].sort();
      if(config.personalized)values[0].sort();
      function setPlaqueGroup(selector,active){
        var group=root.querySelector(selector);
        if(!group)return;
        group.hidden=!active;
        group.querySelectorAll('input,textarea').forEach(function(input){
          input.disabled=!active;
          input.required=active&&input.hasAttribute('data-plaque-required');
          if(!active)input.setCustomValidity('');
        });
      }
      function updatePlaque(){
        if(!config.personalized)return;
        var code=choices[0].charAt(0);
        var count=code==='D'?4:1;
        root.querySelector('[data-plaque-positions]').hidden=code!=='D';
        root.querySelector('[data-plaque-model-info]').textContent=config.plaqueCopy[code]||choices[0];
        root.querySelectorAll('[data-plaque-photo]').forEach(function(group){
          var active=Number(group.dataset.plaquePhoto)<=count;
          group.hidden=!active;
          var input=group.querySelector('input');
          input.disabled=!active;
          input.required=active;
          if(!active)input.setCustomValidity('');
        });
        setPlaqueGroup('[data-plaque-music]',code!=='E');
        setPlaqueGroup('[data-plaque-names]',code==='E');
        setPlaqueGroup('[data-plaque-date]',code==='D'||code==='E');
        setPlaqueGroup('[data-plaque-message]',['A','C','D'].includes(code));
      }
      if(config.personalized){
        root.querySelectorAll('[data-plaque-upload]').forEach(function(input){
          input.addEventListener('change',function(){
            var file=input.files&&input.files[0];
            var valid=!file||(['image/jpeg','image/png','image/webp'].includes(file.type)&&file.size<=10*1024*1024);
            input.setCustomValidity(valid?'':config.plaqueCopy.fileError);
            var preview=input.parentElement.querySelector('[data-plaque-file-preview]');
            if(preview.dataset.objectUrl)URL.revokeObjectURL(preview.dataset.objectUrl);
            preview.hidden=!file||!valid;
            if(file&&valid){var url=URL.createObjectURL(file);preview.src=url;preview.dataset.objectUrl=url;}
            if(!valid)input.reportValidity();
          });
        });
      }
      function setImage(src,alt){
        if(!image||!src)return;
        image.removeAttribute('srcset');
        image.src=src;
        image.alt=alt||'';
        root.querySelectorAll('[data-photo]').forEach(function(button){button.setAttribute('aria-pressed',String(button.dataset.photo===src));});
      }
      function update(){
        var variant=variants.find(function(v){return v.choices.every(function(value,i){return value===choices[i];});});
        if(!variant)return;
        current=variant;
        select.value=String(variant.id);
        root.querySelector('[data-premium-price]').textContent=variant.price;
        root.querySelector('[data-sticky-price]').textContent=variant.price;
        mainBuy.disabled=!variant.available;
        root.querySelector('[data-buy-label]').textContent=variant.available?config.labels.add:config.labels.unavailable;
        var stickyBuy=root.querySelector('[data-sticky-buy]');
        stickyBuy.disabled=!variant.available;
        stickyBuy.textContent=variant.available?config.labels.addShort:config.labels.unavailable;
        stock.textContent=variant.available?config.labels.available:config.labels.unavailable;
        stock.classList.toggle('is-unavailable',!variant.available);
        root.querySelector('[data-selection-summary]').textContent=choices.join(' · ');
        setImage(variant.image,variant.alt);
        updatePlaque();
        var url=new URL(window.location.href);
        url.searchParams.set('variant',String(variant.id));
        window.history.replaceState({},'',url);
      }
      function renderPickers(focusIndex,focusValue){
        pickers.replaceChildren();
        names.forEach(function(name,index){
          if(values[index].length<=1)return;
          var field=document.createElement('fieldset');
          field.className='eex-fieldset';
          var legend=document.createElement('legend');
          legend.appendChild(document.createTextNode(name));
          var chosen=document.createElement('span');
          chosen.className='eex-current-choice';
          chosen.textContent=' — '+choices[index];
          legend.appendChild(chosen);
          field.appendChild(legend);
          var options=document.createElement('div');
          options.className='eex-choices';
          var visual=['baby','tooth','bracelet'].includes(config.kind)||(config.personalized&&index===0);
          if(visual)options.classList.add('has-images');
          values[index].forEach(function(value){
            var button=document.createElement('button');
            button.type='button';
            button.className='eex-choice';
            button.setAttribute('aria-pressed',String(value===choices[index]));
            button.setAttribute('aria-label',value);
            var canBuy=variants.some(function(v){return v.available&&v.choices.every(function(item,j){return j===index?item===value:item===choices[j];});});
            button.disabled=!canBuy;
            if(!canBuy)button.title=config.labels.unavailable;
            var color=colors[value];
            if(color){
              var swatch=document.createElement('span');
              swatch.className='eex-swatch';
              swatch.setAttribute('aria-hidden','true');
              swatch.style.setProperty('--swatch',color);
              button.appendChild(swatch);
            }
            if(visual){
              var candidate=variants.find(function(v){return v.choices[index]===value;});
              if(candidate&&candidate.image){
                var preview=document.createElement('img');
                preview.src=candidate.thumb||candidate.image;
                preview.alt='';
                preview.loading='lazy';
                preview.width=180;
                preview.height=150;
                button.appendChild(preview);
                button.classList.add('has-image');
              }
            }
            var label=document.createElement('span');
            label.textContent=value.replace(/^\d{2} — /,'');
            if(config.kind==='album'&&index===1){
              var size=document.createElement('span');
              size.className='eex-format-description';
              size.textContent=formatSizes[value]||'';
              label.appendChild(size);
            }
            button.appendChild(label);
            button.addEventListener('click',function(){
              choices[index]=value;
              update();
              renderPickers(index,value);
            });
            options.appendChild(button);
            if(index===focusIndex&&value===focusValue)requestAnimationFrame(function(){button.focus({preventScroll:true});});
          });
          field.appendChild(options);
          pickers.appendChild(field);
        });
      }
      updatePlaque();
      renderPickers();
      pickers.hidden=false;
      root.querySelector('[data-native-picker]').hidden=true;
      root.querySelector('[data-selection-summary]').textContent=choices.join(' · ');
      select.addEventListener('change',function(){
        var variant=variants.find(function(v){return String(v.id)===select.value;});
        if(variant){choices=variant.choices.slice();update();renderPickers();}
      });
      root.querySelectorAll('[data-photo]').forEach(function(button){button.addEventListener('click',function(){setImage(button.dataset.photo,button.dataset.photoAlt);});});
      var more=root.querySelector('[data-toggle-gallery]');
      if(more)more.addEventListener('click',function(){
        var expanded=more.getAttribute('aria-expanded')!=='true';
        more.setAttribute('aria-expanded',String(expanded));
        more.textContent=expanded?config.labels.lessPhotos:config.labels.morePhotos;
        root.querySelector('.eex-thumbnails').classList.toggle('is-expanded',expanded);
        root.querySelectorAll('[data-extra-photo]').forEach(function(button){button.hidden=!expanded;});
      });
      var dialog=root.querySelector('[data-photo-dialog]');
      root.querySelector('[data-open-photo]').addEventListener('click',function(){
        if(!image)return;
        var enlarged=root.querySelector('[data-dialog-image]');
        enlarged.src=image.src;
        enlarged.alt=image.alt;
        dialog.showModal();
      });
      root.querySelector('[data-close-photo]').addEventListener('click',function(){dialog.close();});
      dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});
      if('IntersectionObserver' in window){
        var observer=new IntersectionObserver(function(entries){
          root.querySelector('[data-premium-sticky]').hidden=!(entries[0].boundingClientRect.top<0&&!entries[0].isIntersecting);
        });
        observer.observe(mainBuy);
      }
    });
  }
  initPremium();
  document.addEventListener('shopify:section:load',initPremium);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["empreinte-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.eep-media').forEach((gallery) => {
  const main = gallery.querySelector('.eep-main img');
  if (!main) return;
  gallery.querySelectorAll('[data-eep-image]').forEach((button) => {
    button.addEventListener('click', () => {
      main.removeAttribute('srcset');
      main.src = button.dataset.eepImage;
      main.alt = button.querySelector('img').alt;
      gallery.querySelectorAll('[data-eep-image]').forEach((item) => {
        item.setAttribute('aria-pressed', String(item === button));
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["empreinte-souvenirs-product"]) return;
  try {
    
(function(){
  function initSouvenirs(){
    document.querySelectorAll('[data-ee-souvenir]').forEach(function(root){
      if(root.dataset.ready)return;
      root.dataset.ready='true';
      var image=root.querySelector('.ees-hero-image');
      var select=root.querySelector('[data-souvenir-select]');
      var buy=root.querySelector('[data-souvenir-buy]');
      function showImage(src,alt){
        if(!image||!src)return;
        image.removeAttribute('srcset');
        image.src=src;
        image.alt=alt||'';
        root.querySelectorAll('.ees-thumb').forEach(function(thumb){
          thumb.setAttribute('aria-pressed',String(thumb.dataset.imageSrc===src));
        });
      }
      root.querySelectorAll('.ees-thumb').forEach(function(thumb){
        thumb.addEventListener('click',function(){showImage(thumb.dataset.imageSrc,thumb.dataset.imageAlt);});
      });
      select.addEventListener('change',function(){
        var option=select.options[select.selectedIndex];
        var available=option.dataset.available==='true';
        root.querySelector('[data-souvenir-price]').textContent=option.dataset.price;
        buy.disabled=!available;
        buy.textContent=available?root.dataset.addLabel+' — '+option.dataset.price:root.dataset.unavailableLabel;
        var status=root.querySelector('[data-souvenir-status]');
        status.textContent=available?root.dataset.availableLabel:root.dataset.unavailableLabel;
        showImage(option.dataset.image,option.dataset.alt);
      });
    });
  }
  initSouvenirs();
  document.addEventListener('shopify:section:load',initSouvenirs);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
